

















































import { Component, Vue, Prop } from 'vue-property-decorator';
import ShowFilePreviewModal from '@/components/storage/modals/ShowFilePreviewModal.vue'

@Component({
  components: {
    ShowFilePreviewModal,
  },
})
export default class RecentUpdateFileList extends Vue {
  @Prop(Object) private file!: object;
  @Prop(Array) private files!: Array<{ name: string; type: string; src: string; }>;
  @Prop(Boolean) private isShowFilePreviewModal!: boolean;
  @Prop(Object) private switchShowFilePreviewModal!: object;
}
